import PropTypes from 'prop-types';
import React from 'react';
import { CartCheck, CartPlus, Check, Info } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import Loader from '../framework/loader';

const ItemButtonSlim = ({ handleAction, inCart, isLoading }) => {
	const { t } = useTranslation('component_item_button_slim');
	const statuses = {
		no: {
			className: 'btn-accent btn-circle icon-container-lg',
			icon: <CartPlus className="p-1" />,
			translation: 't1',
		},
		other: {
			className: 'bg-green-100 btn-circle icon-container-lg',
			icon: <Check className="" />,
			translation: 't2',
		},
		replaced: {
			className: 'bg-green-100 btn-circle icon-container-lg',
			icon: <Info className="" />,
			translation: 't3',
		},
		yes: {
			className: 'btn-success text-white btn-circle icon-container-lg',
			icon: <CartCheck className="p-1" />,
			translation: 't4',
		},
	};

	return (
		<button
			aria-label={t(`${statuses[inCart.status]?.translation}`)}
			className={`btn rounded-pill ${statuses[inCart.status]?.className}`}
			onClick={handleAction}
		>
			{isLoading && <Loader color="light" />}
			{!isLoading && statuses[inCart.status]?.icon && (
				<>{statuses[inCart.status]?.icon}</>
			)}
		</button>
	);
};

ItemButtonSlim.propTypes = {
	handleAction: PropTypes.func,
	inCart: PropTypes.object,
	isLoading: PropTypes.bool,
};

export default ItemButtonSlim;
